/**
 * Utility to check if device login feature (platform authenticator) is available 
 * such as fingerprint, face recognition, Windows Hello PIN or Device password (secure)
 * Works in modern browsers that support WebAuthn
 *
 * @returns {Promise<boolean>} true if device login feature is available, false otherwise
 */
export async function isPlatformAuthenticatorAvailable() {
    try {
        // Check if WebAuthn API is supported
        if (typeof window.PublicKeyCredential === "undefined") {
            return false
        }

        // Check if a user-verifying platform authenticator (biometrics) is available
        const available = await PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable()
        return available
    } catch (err) {
        console.error("Error checking device login feature availability:", err)
        return false
    }
}
